import type { AutocompleteOption } from "@/types/form-fields"

export enum ProductOrigin {
  SUPPLIER = "supplier",
  OTHER = "other",
}

export interface ProductOriginFormType {
  exactLocation: string | null
  country?: string | null
  region?: AutocompleteOption<string | number> | null
  city?: string | null
  originType: ProductOrigin
}

export interface ProductOriginSubmissionType {
  exactLocationId: string | null
  regionIsoCode: string | number | null
  city: string | null
  countryIsoCode: string | null
}
